import React from "react";
import { useIntl } from "react-intl";
var VideoContent = function(param) {
    var content = param.content;
    var baseAssetPath = window.location.origin;
    var formatMessage = useIntl().formatMessage;
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ React.createElement("video", {
        width: "400",
        controls: true
    }, /*#__PURE__*/ React.createElement("source", {
        src: "".concat(baseAssetPath).concat(content),
        type: "video/mp4"
    }), formatMessage({
        id: "messages.dev_app.video"
    })));
};
export default VideoContent;

//# sourceMappingURL=VideoContent.js.map